import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import AdminOnly from "~/components/AdminOnly";
import { useParams } from "react-router-dom";
import { Button } from "primereact/button";
import useShareholderProfileAddress from "./useShareholderProfileAddress";
import { useShareHolderDetails } from "../ShareHolderDetail";
import Notification from "../../entities/notification/Notification";
import ShareholderAddress from "../ShareholderAddress";
import AuditSidebar from "../../audit-sidebar/AuditSidebar";
import API_ROUTES from "../../../api-routes";
const ShareholderProfileAddress = () => {
  const {
    regData: { type: shareholderType, addressData, entityData },
    setRegData,
    loading,
  } = useShareHolderDetails();
  const { id } = useParams();

  const {
    isEditing,
    successMessage,
    setSuccessMessage,
    isSaveDisabled,
    setIsSaveDisabled,
    isLoading,
    handleEditClick,
    handleDiscardClick,
    handleSaveClick,
    addressData: localAddressData,
    setAddressData,
  } = useShareholderProfileAddress(
    shareholderType,
    addressData,
    (newReg) => setRegData((prev) => ({ ...prev, ...newReg })),
    entityData,
    loading,
  );
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  useEffect(() => {
    setAddressData(addressData);
  }, [addressData]);

  const auditLabels = () => {
    return {
      create: "Address Added ",
      update: "Address Updated",
      delete: "Address Deleted",
    };
  };
  return (
    <Card className="personal-info-card">
      <div className="personal-info-container flex justify-content-between formgrid grid grid-nogutter">
        <div>
          <p className="address-heading">Registered Address</p>
        </div>
        <AdminOnly>
          <div className="flex gap-3">
            {isEditing ? (
              <div className="flex gap-2">
                <Button className="edit-button" onClick={handleDiscardClick}>
                  Discard
                </Button>
                <Button
                  type="submit"
                  className={`save-changes-btn ${isSaveDisabled && "disable"}`}
                  disabled={isSaveDisabled}
                  onClick={handleSaveClick}
                  loading={isLoading}
                >
                  Save Changes
                </Button>
              </div>
            ) : (
              <>
                <Button
                  className="edit-button"
                  onClick={() => setAuditSidebarVisible(true)}
                >
                  View History
                  <span className="pi pi-history mb-1 ml-2" />
                </Button>
                <Button
                  className="edit-info-button"
                  onClick={() => {
                    handleEditClick();
                    setIsSaveDisabled(true);
                  }}
                >
                  Edit
                  <span className="pi pi-pencil text-xs ml-2"></span>
                </Button>
              </>
            )}
          </div>
        </AdminOnly>
        <Notification
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
        />
      </div>
      <ShareholderAddress
        addressData={{
          ...localAddressData,
          cityLoader: !localAddressData?.stateOptions?.length,
          stateLoader: !localAddressData?.stateOptions?.length,
        }}
        setAddressData={setAddressData}
        setBtnToggle={setIsSaveDisabled}
        type={shareholderType}
        isNewAddress={false}
        isEdit={isEditing}
        isLoading={loading}
      />
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Address"
          endpoint={API_ROUTES.FETCH_ADDRESS_AUDIT}
          id={id}
          objectType="shareholder"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
    </Card>
  );
};

export default ShareholderProfileAddress;
